export const gamAssetMapping = (data, isHolder) => {
    return [
        {
            assetId: data.assetId,
            material: data.material,
            isHolder: !!isHolder,
        },
    ];
};
